import { render, staticRenderFns } from "./VRangeSlider.vue?vue&type=template&id=21841d31&"
import script from "./VRangeSlider.vue?vue&type=script&lang=js&"
export * from "./VRangeSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports